module.exports = __webpack_public_path__ + "static/before-2-9523f9aa1376416182812d5445e3e440.png";